import { Rectangle } from './../../../tools/rectangle';
import { RatioUtil } from 'src/app/tools/ratio.utils';
import { LayerData, LAYER_TYPE } from '../layer/layer.data';
import { ImageLayerData } from '../layer/image-layer.data';
import { SquareShapeLayerData } from '../layer/square-shape-layer.data';
import { environment } from 'src/environments/environment';
import { TextLayerData } from '../layer/text-layer.data';
import { SVGShapeLayerData } from '../layer/svg-shape-layer.data';

import FontFaceObserver from 'fontfaceobserver';
import { TintableLayerData } from '../layer/tintable-layer.data';
import { UserImageData } from 'src/app/data/user/user-image.data';
import { ContextData } from 'src/app/data/context.data';
import { FontsLibrairie } from 'src/app/data/fonts.librairie';
import { WingdingsShapeLayerData } from '../layer/wingdings-shape-layer.data';
import { LineShapeLayerData } from '../layer/line-shape-layer.data';
import { CircleShapeLayerData } from '../layer/circle-shape-layer.data';
import { TriangleShapeLayerData } from '../layer/triangle-shape-layer.data';

declare var fabric:any;

export class DesignData {

  private _data:any;
	private _dico:Array<any>;
	private _fonts:Array<any>;
	private _images:Array<UserImageData>;

	constructor() {

  }

  /**
	 * data
	 */
  public setData(value: any):Promise<boolean> {
	// console.log("DesignData.setData()",value);
		this._data = value;
		this._data.layers = this._data.layers.filter((layer:any)=>{
			if(layer.type == LAYER_TYPE.TEXT && !layer.text && !layer.properties.defaultText) return false;
			return true;
		});

    if (this._dico == null) {
			this._dico = [];
    }
    this._fonts = [];
		this._images = [];

		let src: any;
		for (let layer of this._data.layers) {

			switch (layer.type) {
				case LAYER_TYPE.BACKGROUND:
					if (layer.properties.type === 1 || layer.properties.type == 2) {
						src = layer.src;
						if (!this._dico[src]) {
							this._dico[src] = {
								type: 'image',
							};
						}
					}
					break;
				case LAYER_TYPE.PICTURE:
					src = layer.src;
					if (!this._dico[src]) {
						this._dico[src] = {
							type: 'image'
						};

					}
					break;
				case LAYER_TYPE.SVG:
					src = layer.src;
					if (src && !this._dico[src]) {
						this._dico[src] = {
							type: 'shape'
						};
					}
					break;
				case LAYER_TYPE.SHAPE:
					if (layer.properties.type === 0) {
					} else if (layer.properties.type === 1) {
					} else if (layer.properties.type == 2) {
					} else if (layer.properties.type == 3) {
					} else if (layer.properties.type == 4) {
						if (!this._dico[layer.properties.font]) {
							this._dico[layer.properties.font] = {
								type: 'font',
								name: layer.properties.font
							};
						}
					} else {

					}

					break;
				case LAYER_TYPE.TEXT:
					if (!this._dico[layer.properties.font]) {
						this._dico[layer.properties.font] = {
							type: 'font',
							name: layer.properties.font
						};
					}
					break;
				case LAYER_TYPE.LOGO:
					src = ContextData.LOGO_PATH;
					if (!this._dico[src]) {
						this._dico[src] = {
							type: 'shape'
						};
					}
					break;
			}
		}

		return new Promise((resolve, reject) => {
			let promises:Array<Promise<any>> = [];

			// console.log(this._dico);

			for (let url in this._dico) {
				switch (this._dico[url].type) {
					case 'image':
						promises.push(new Promise((resolve, reject) => {
							// create an image object
							let img = new Image();
							img.crossOrigin = 'Anonymous';
							img.onload = () => {
								let targetWidth;
								let targetHeight;
								if(Math.max(img.width,img.height) > fabric.textureSize){
									let _imgRect = new Rectangle(0,0,img.width,img.height);
									let _imgMaxRect = new Rectangle(0,0,fabric.textureSize,fabric.textureSize)
									let _rectFit = RatioUtil.scaleToFit(_imgRect,_imgMaxRect)
									targetWidth = _rectFit.width;
									targetHeight = _rectFit.height;
								} else {
									targetWidth = img.width;
									targetHeight = img.height;
								}
								var canvas = document.createElement("canvas");
								canvas.width = targetWidth;
								canvas.height = targetHeight;
								var ctx = canvas.getContext("2d");
								ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
								var dataURL = canvas.toDataURL("image/png");
								this._dico[url].width = targetWidth;
								this._dico[url].height = targetHeight;
								this._dico[url].data = dataURL;
								resolve(true);
							};
							img.onerror = (err) => {
								reject(err);
							};
							img.src = environment.ASSETS_SERVER + url;
						}));
						break;
					case 'shape':
						promises.push(new Promise((resolve, reject) => {
							var xhr = new XMLHttpRequest;
							xhr.open('GET', environment.ASSETS_SERVER + url);
							xhr.responseType = 'text';
							xhr.overrideMimeType('text/xml');
							xhr.onload = () => {
								if (xhr.readyState === xhr.DONE) {
									if (xhr.status === 200) {
										this._dico[url].data = xhr.responseText;
										resolve(true);
									} else {
										reject(false);
									}
								}
							};
							xhr.send();
						}));
						break;
					case 'font':
						FontsLibrairie.addAvailableFont(this._dico[url].name);
						promises.push(FontsLibrairie.loadFont(this._dico[url].name));
						break;
				}
			}

			Promise.all(promises).then(function () {
        // TypoError replace

				resolve(true);
			}).catch(error => {
				console.error(error);
				reject(error);
			});
    });
  }


  /**
	 * Get layer
	 */
	public getLayer(index:number):LayerData {
		var data:any = this._data.layers[index];
		var layerData:LayerData;
		var layerType:number = data.type;

		var locks:any;
		if (data.locking) {
			locks = {position:data.locking.position, rotation:data.locking.rotation, size:data.locking.size, deletion:data.locking.delete, depth:false};
		} else {
			locks = {position:false, rotation:false, size:false, deletion:false, depth:false};
		}

		var x: number = data.properties.x ? +data.properties.x : 0;
		var y: number = data.properties.y ? +data.properties.y : 0;
		var width:number = data.properties.width ? +data.properties.width : NaN;
		var height:number = data.properties.height ? +data.properties.height : NaN;
		var color: string = data.properties.color ? data.properties.color : null;
		var rotation:number = data.properties.rotation ? +data.properties.rotation : 0;
		var alpha:number = data.properties.alpha ? +data.properties.alpha : 1;
		var source:string = (data.design === 1) ? LayerData.DESIGN : LayerData.DUPLICATION;
		var image:UserImageData;
		var type:number;
		var src:string;
		switch (layerType) {
			case LAYER_TYPE.BACKGROUND:
				locks.depth = true;
				locks.crop = true;
				type = data.properties.type;
				if (data.properties.type === 1 || data.properties.type == 2) {
					if (data.properties.type == 2) {
						locks.tint = true;
					}
					src = data.src;
					image = new UserImageData(-1, "", src, this._dico[src].data, 0, null);
					image.width = this._dico[src].width;
					image.height = this._dico[src].height;
					layerData = new ImageLayerData(image, null, color, x, y, width, height, rotation, alpha, locks, source);
					// console.log(image,layerData,width,height);
				} else {
					layerData = new SquareShapeLayerData(color, 0, 0, 0, 0, 0, alpha, locks, source);
				}
				layerData.special = "background";
				break;
			case LAYER_TYPE.PICTURE:
				//locks.crop = true;
				locks.tint = true;
				src = data.src;
				image = new UserImageData(-1, "", src, this._dico[src].data, 0, null);
				image.width = this._dico[src].width;
				image.height = this._dico[src].height;
				layerData = new ImageLayerData(image, data.crop, null, x, y, width, height, rotation, alpha, locks, source);
				break;
			case LAYER_TYPE.SHAPE:
			case LAYER_TYPE.SVG:

				if (data.properties.type === 0) {
					layerData = new SquareShapeLayerData(color, x, y, width, height, rotation, alpha, locks, source);
				} else if (data.properties.type === 1) {
					layerData = new TriangleShapeLayerData(color, x, y, width, height, rotation, alpha, locks, source);
				} else if (data.properties.type == 2) {
					layerData = new CircleShapeLayerData(color, x, y, width, height, rotation, alpha, locks, source);
				} else if (data.properties.type == 3) {
					layerData = new LineShapeLayerData(color, x, y, width, height, rotation, alpha, locks, source);
				} else if (data.properties.type == 4) {
					layerData = new WingdingsShapeLayerData(data.text, data.properties.font, color, x, y, width, height, rotation, alpha, locks, source);
				} else {
					src = data.src;
					layerData = new SVGShapeLayerData(src, this._dico[src].data, color, x, y, width, height, rotation, alpha, locks, source);
				}
				break;
			case LAYER_TYPE.TEXT:
				layerData = new TextLayerData(
					data.text ? data.text : data.properties.defaultText,
					data.properties.font,
					data.properties.size,
					color,
					data.properties.bold,
					data.properties.italic,
					data.properties.underlined,
					data.properties.justification,
					data.properties.leading,
					x, y, width, height, rotation, alpha, locks, source);
				TextLayerData.DEFAULT_FONT = data.properties.font;
				TextLayerData.DEFAULT_SIZE = data.properties.size;
				break;
			case LAYER_TYPE.LOGO:
				locks.position = true;
				locks.rotation = true;
				locks.size = true;
				locks.deletion = true;
				locks.tint = true;
				locks.depth = false;
				src = ContextData.LOGO_PATH;
				layerData = new SVGShapeLayerData(src, this._dico[src].data, color, x, y, width, height, rotation, alpha, locks, source);
				layerData.special = "logo";
				break;

		}

		if (color) {
			TintableLayerData.DEFAULT_COLOR = color;
		}
		// console.log(layerData);


		return layerData;
	}

  /**
   * length
   */
  public get templateId():number {
    return this._data.labelId;
	}

  /**
   * length
   */
  public get length():number {
    return this._data.layers.length;
	}

	/**
   * Fonts
   */
	public get fonts(): any {
		return this._fonts;
	}

  /**
   * Cleanup
   */
  public cleanup():void {
    this._data = null;
  }

}

